import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PropTypes } from 'prop-types';
import { IdentityVerificationUI } from '../../components/IdentityVerificationWebUI';
import {
  brandId,
  bankId,
  accessToken,
  getSingleEntry,
  apiBaseUrlPaas
} from '../../infrastructure/config/selectors';
import { getNextCall } from '../../infrastructure/offers';
import { toggleLoading, callGetNext } from '../../store/dataCapture';
import {
  CASE_ID,
  CASE_SUBTYPE,
  CASE_TYPE_EXISTING,
  EXISTING_NEW_BUSINESS,
  OFFER_CASE_ID
} from '../../utils/constants';
import getClientContext from './getClientContext';
import { Content } from '../../infrastructure/content';

const IDVQuestionsContainer = ({
  apiBaseUrlPaas,
  accessToken,
  bankId,
  caseId,
  getNextCall,
  toggleLoading,
  caseType,
  callGetNext
}) => {
  return (
    <Content>
      {({ loaderTitle, loaderBody }) => (
        <div>
          <IdentityVerificationUI
            onAnswersSubmitted={getNextCall}
            onError={callGetNext}
            onLoadingStateChanged={toggleLoading}
            env={{ apiBaseUrlLiberty: apiBaseUrlPaas }}
            bankId={bankId}
            caseInfo={{
              id: caseId,
              type: 'bsap',
              subType: caseType === CASE_TYPE_EXISTING ? EXISTING_NEW_BUSINESS : caseType,
              screenshotContext: 'capture'
            }}
            clientContext={getClientContext()}
            accessToken={accessToken}
            loaderProps={{
              title: loaderTitle,
              body: loaderBody
            }}
            baseUrl={apiBaseUrlPaas}
          />
        </div>
      )}
    </Content>
  );
};
IDVQuestionsContainer.propTypes = {
  brandId: PropTypes.string,
  bankId: PropTypes.string,
  accessToken: PropTypes.string,
  clientContext: PropTypes.string
};

const actionCreators = {
  getNextCall,
  toggleLoading,
  callGetNext
};

const mapStateToProps = state => ({
  brandId: brandId(state) || '',
  bankId: bankId(state) || '',
  accessToken: accessToken(state) || '',
  caseId: getSingleEntry(state, CASE_ID) || getSingleEntry(state, OFFER_CASE_ID),
  caseType: getSingleEntry(state, CASE_SUBTYPE),
  apiBaseUrlPaas: apiBaseUrlPaas(state) || ''
});
const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(IDVQuestionsContainer);
